import React from "react";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { Typography } from "@material-ui/core";

import TrimmedText from "components/TrimmedText";

import { Container, IconContainer, ClearIconContainer } from "./styles";

type Props = {
  title: string;
  icon: string;
  onRemove?: () => void;
  isEditMode?: boolean;
};

class EquipmentCard extends React.Component<Props> {
  render() {
    const { title, icon, isEditMode, onRemove } = this.props;

    return (
      <Container>
        <IconContainer image={icon} />
        <TrimmedText lines={1} text={title}>
          <Typography variant="subtitle1">{title}</Typography>
        </TrimmedText>
        {isEditMode && (
          <ClearIconContainer onClick={onRemove}>
            <DeleteOutlineIcon />
          </ClearIconContainer>
        )}
      </Container>
    );
  }
}

export default EquipmentCard;
